import { BaseConst } from './baseConst';

export class CmElementConst extends BaseConst {

    // 字段
    static LabelID = 'LabelID';
    static IsMultiLanguage = 'IsMultiLanguage';
    static DefaultValue = 'DefaultValue';
    static DefaultValueType = 'DefaultValueType';
    static IsRequire = 'IsRequire';
    static Readonly = 'Readonly';
    static IsVirtual = 'IsVirtual';
    //具体空间数据类型
    static GeometryType = 'GeometryType';

    // 数据类型
    static MDataType = 'MDataType';
    static Length = 'Length';
    static Precision = 'Precision';

    // 对象类型
    static ObjectType = 'ObjectType';
    static ContainEnumValues = 'ContainEnumValues';
    static EnumIndexType = 'EnumIndexType';
    static ChildAssociations = 'ChildAssociations';

    // 业务字段
    static IsUdt = 'IsUdt';
    static UdtPkgName = 'UdtPkgName';
    static UdtID = 'UdtID';
    static UnifiedDataType = 'UnifiedDataType';
    // static BelongObject = 'BelongObject';

    // 关联
    static KeyCollection = 'KeyCollection';
    static RefElementCollection = 'RefElementCollection';
    static BelongElement = 'BelongElement';
    static RefModelID = 'RefModelID';
    static RefModelName = 'RefModelName';
    static RefModelCode = 'RefModelCode';
    static RefModelPkgName = 'RefModelPkgName';
    static RefModelMode = 'RefModelMode';
    static AssoConditions = 'AssoConditions';

    // 关联外键
    static TargetElement = 'TargetElement';
    static SourceElement = 'SourceElement';
    static TargetElementDisplay = 'TargetElementDisplay';
    static SourceElementDisplay = 'SourceElementDisplay';
    static RefdataModelName = 'RefdataModelName';

    // 编号规则
    static BillCodeConfig = 'BillCodeConfig';

    // 动态属性集合
    static DynamicPropSetInfo = 'DynamicPropSetInfo';
    // static EnableDynamicProp = 'EnableDynamicProp';
    static DynamicPropRepositoryComp = 'DynamicPropRepositoryComp';
    static DynamicPropSerializerComp = 'DynamicPropSerializerComp';
}
